let initial;

    initial = { on: false};


const initials = initial;
const DonePayment = (state= initials , action ) =>{
    if(action.type === "PAYMENT" ){
        return {on:action.on};
    }else{ 
        return state;
    }
   
}

export default DonePayment;